export const SELECTABLE_COLUMN_WIDTH = '40px';
export const MAX_TEMPLATE_NAME_LENGTH = 150;
export const TEMPLATE_LABEL_BOX_WIDTH = 334;
export const TEMPLATE_LABEL_BOX_WIDTH_WITH_VISIBILITY_ICON = 310;
